import React, { Fragment, useEffect, useState } from "react";
import { Button, Row, Col, Form, Input, message, Select } from 'antd';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Image from 'helpers/Image';
import "../style.css";
import { useAddDepartment, useEditDepartment } from "hooks/configuration/department/Department"

const FormDepartment = () => {

    let navigate = useNavigate();
    const [form] = Form.useForm();
    const editData = useLocation();
    const [serverErrors, setServerErrors] = useState({});

    const create = editData.pathname === "/configuration/department/create";

    const status = [
        { 'label': "Active", "value": true },
        { 'label': "InActive", "value": false },
    ]

    const { mutate: addDepartment, isLoading: Loading } = useAddDepartment();
    const { mutate: editDepartment, isLoading: editLoading } = useEditDepartment();

    const onFinish = (formDatas) => {
        if (create) {
            const submitData = { ...formDatas };
            submitData.departmentName = formDatas.departmentName.trim().split(/ +/).join(' ');
            let formData = JSON.stringify(submitData)
            addDepartment(formData, {
                onSuccess: (item) => {
                    if (item?.statusCode === 200) {
                        message.success(item?.message);
                        navigate("/configuration/department");
                    } else {
                        message.error(item?.message);
                    }
                },
                onError: (error) => {
                    if (error?.response?.data?.errorMessages) {
                        const errorMessages = error.response.data.errorMessages;
                        setServerErrors(errorMessages);
                    } 
                }
            })
        } else {
            const submitData = { ...formDatas };
            submitData.departmentId = formDatas.departmentId
            submitData.departmentName = formDatas.departmentName.trim().split(/ +/).join(' ');
            submitData.active = formDatas.active
            let formData = JSON.stringify(submitData)
            editDepartment(formData, {
                onSuccess: (item) => {
                    if (item?.statusCode === 200) {
                        message.success(item?.message);
                        navigate("/configuration/department");
                    } else {
                        message.error(item?.message);
                    }
                },
                onError: (error) => {
                    if (error?.response?.data?.errorMessages) {
                        const errorMessages = error.response.data.errorMessages;
                        setServerErrors(errorMessages);
                    }
                }
            })
        }

    }

    const clearError = (name) => {
        setServerErrors(prev => ({ ...prev, [name]: "" }));
    };

    const onChangeHandler = (value) => {
        form.setFieldsValue({ "active": value })
    }

    useEffect(() => {
        if (editData) {
            form.setFieldsValue({
                "departmentId": editData?.state?.departmentId,
                "departmentName": editData?.state?.departmentName,
                "active": editData?.state?.status,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editData]);


    return (
        <Fragment>
            <div className="form-page">
                <div className="form-head form-head-sticky">
                    <div className="form-head-left">
                        <Link to="/configuration/department" className="form-back">
                            <Image name="backArrow.svg" />
                        </Link>
                        <div className="form-title">
                            <h1>{create ? "New Contractor" : `Edit ${editData?.state?.departmentName}`}</h1>
                            <p>{create ? "Add a contractor to group employees under" : "Update this contractor's details"}</p>
                        </div>
                    </div>
                    <div className="form-actions">
                        <Button className="form-cancel" onClick={() => navigate("/configuration/department")}>Cancel</Button>
                        <Button className="form-submit" loading={Loading || editLoading} onClick={() => form.submit()} htmlType="submit">
                            {Loading || editLoading ? null : <Image className="save-img" name="save.svg" />} {create ? "Save" : "Update"}
                        </Button>
                    </div>
                </div>

                <div className="form-card">
                    <Form
                        form={form}
                        onFinish={onFinish}
                        colon={false}
                        layout="vertical">
                        <Form.Item name="departmentId" hidden={true}>
                            <Input />
                        </Form.Item>

                        <section className="form-section">
                            <div className="form-section-head">
                                <h2>Contractor details</h2>
                                <p>The name employees are grouped under across reports.</p>
                            </div>
                            <Row gutter={[24, 0]}>
                                <Col xs={24} sm={12} lg={6}>
                                    <Form.Item label="Contractor Name" name="departmentName" rules={[{ required: true, whitespace: true, message: "Contractor Name is required" }]} validateStatus={serverErrors?.departmentName ? "error" : ""}
                                        help={serverErrors?.departmentName?.[0]}>
                                        <Input placeholder="Enter the contractor name" maxLength={40} onChange={() => clearError("departmentName")}></Input>
                                    </Form.Item>
                                </Col>
                                {create ? null : (
                                    <Col xs={24} sm={12} lg={6}>
                                        <Form.Item label="Status" name="active" rules={[{ required: true, message: 'Required!' }]}>
                                            <Select onChange={onChangeHandler} placeholder={"Select status"} options={status} />
                                        </Form.Item>
                                    </Col>
                                )}
                            </Row>
                        </section>
                    </Form>
                </div>
            </div>
        </Fragment>
    )
}
export default FormDepartment;